import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { theme } from "./Tema";
import { ThemeProvider } from "@mui/system";
import { HelmetProvider } from 'react-helmet-async';

const rootElement = document.getElementById('root');

const AppTree = (
    <HelmetProvider>
        <ThemeProvider theme={theme}>
            <App />
        </ThemeProvider>
    </HelmetProvider>
);

if (rootElement.hasChildNodes()) {
    // react-snap pre-renderizó → hidratamos
    hydrateRoot(rootElement, AppTree);
} else {
    // Carga normal
    createRoot(rootElement).render(AppTree);
}

serviceWorkerRegistration.unregister();
reportWebVitals();